<template>
  <div v-if="legalDocuments && dataProcessor">
    <popup-add-data-controller ref="popupAddDataController" />
    <popup-edit-data-processor ref="popupEditDataProcessor" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">GDPR</h3>
        <p class="mt-5">
          Manage data processor and data controllers for use in legal documents.
          Selected data controllers in a legal form will automatically be added
          to the document.
        </p>
      </vs-col>
      <!--<div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            v-if="$AuthService.hasPermission('vp.crm.legaldocuments.edit')"
            @click="$refs.popupAddDataController.show()"
            type="relief"
            vslor="primary"
            >Add data controller</vs-button
          >
        </vs-row>
      </div>-->
    </vs-row>
    <vs-row class="mt-4">
      <vs-col class="rolecard p-3">
        <vs-card>
          <div slot="header">
            <vs-row vs-justify="space-between">
              <h6>Data processor</h6>
              <div>
                <feather-icon
                  icon="EditIcon"
                  v-if="
                    $AuthService.hasPermission('vp.crm.legaldocuments.edit')
                  "
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="$refs.popupEditDataProcessor.show()"
                />
              </div>
            </vs-row>
          </div>
          <div>
            <vs-row>
              <vs-col vs-w="4">Name</vs-col>
              <vs-col vs-w="8"
                ><i>{{ dataProcessor.name }}</i></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">VAT no.</vs-col>
              <vs-col vs-w="8"
                ><i>{{ dataProcessor.vat }}</i></vs-col
              >
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-w="4">Address</vs-col>
              <vs-col vs-w="8"
                ><i
                  >{{ dataProcessor.street }}<br />{{ dataProcessor.zip }}
                  {{ dataProcessor.city }}<br />{{ dataProcessor.country }}</i
                ></vs-col
              >
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->
      <h5 class="mt-6">Data controllers</h5>

      <vs-table
        ref="table"
        class="mt-4"
        pagination
        search
        :data="legalDocuments"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <vs-button
              ref="createButton"
              id="create-button"
              class="vs-con-loading__container"
              v-if="$AuthService.hasPermission('vp.crm.legaldocuments.edit')"
              @click="$refs.popupAddDataController.show()"
              type="relief"
              vslor="primary"
              >Add data controller</vs-button
            >
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Controller name</vs-th>
          <vs-th>VAT</vs-th>
          <vs-th>Address</vs-th>
          <vs-th>E-mail</vs-th>
          <vs-th>Phone</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.name }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.vat }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ `${tr.street}, ${tr.zip} ${tr.city}` }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.email }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.phone }}
                </p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  v-if="
                    $AuthService.hasPermission('vp.crm.legaldocuments.edit')
                  "
                  @click.stop="confirmDelete(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import PopupAddDataController from "./LegalDocument/PopupAddDataController.vue";
import PopupEditDataProcessor from "./LegalDocument/PopupEditDataProcessor.vue";
import { mapGetters } from "vuex";
export default {
  components: { PopupAddDataController, PopupEditDataProcessor },
  data() {
    return {
      removeId: "",
    };
  },
  methods: {
    async confirmDelete(tr) {
      this.removeId = tr.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this data controller?",
        accept: this.remove,
      });
    },
    async remove() {
      this.$vs.loading();
      await this.$store.dispatch(
        "legalDocuments/deleteController",
        this.removeId
      );
      this.$vs.loading.close();
    },
  },
  computed: {
    ...mapGetters({
      legalDocuments: "legalDocuments/controllers",
      dataProcessor: "legalDocuments/dataProcessor",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("legalDocuments/getDataProcessor");
    await this.$store.dispatch("legalDocuments/getAllControllers");
    this.$vs.loading.close();
  },
};
</script>


<style lang="scss" scoped>
.role-table {
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.rolecard {
  &.deactivated {
    opacity: 0.75;
  }

  min-width: 380px;
  max-width: 380px;

  .con-vs-card {
    border: 2px solid #ccc;
  }

  .vs-card--content {
    margin-bottom: 0;
  }

  .vs-card--footer {
    padding: 6px 12px;
    margin-top: 0;
    transform: none;
    background-color: #ccc;
    font-size: 0.8rem;
  }
}
</style>